import React from "react";
import "./css/EmptyState.css";

export default function EmptyState({
    icon = "📭",
    title = "Nothing here yet",
    description = "Please stay tuned.",
    action,
}) {
    return (
        <div className="empty-state">
            <div className="empty-icon">{icon}</div>
            <h3 className="empty-title">{title}</h3>
            <p className="empty-desc">{description}</p>
            {action && <div className="empty-action">{action}</div>}
        </div>
    );
}
